export default __webpack_public_path__ + "static/media/22-min.9ce42d0c.png";